/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/16
 */
import React from 'react';
import {Route, Switch} from 'react-router';
import {ConnectedRouter} from 'react-router-redux';
import history from './history';
import EnsureLoginRoute from './ensureLoginRoute';
import Home from '../components/home';
import Search from '../components/search'
import Step1 from '../components/step1';
import Step2 from '../components/step2';
import Step3 from '../components/step3';
import Protocol from '../components/protocol';
import NotFound from '../components/notFound';
import Message from '../components/common/message';

const Routes = () => {
  return <ConnectedRouter history={history}>
    <div>
      <Switch>
        <EnsureLoginRoute path="/view/appraisal/:pid" exact strict component={Step1}/>
        <EnsureLoginRoute path="/view/appraisal/:pid/step1" exact strict component={Step1}/>
        <EnsureLoginRoute path="/view/appraisal/:pid/step2" exact strict component={Step2}/>
        <EnsureLoginRoute path="/view/appraisal/:pid/step3" exact strict component={Step3}/>
        <Route exact path="/" component={Home}/>
        <Route exact path="/view" component={Home}/>
        <Route exact path="/view/search" component={Search}/>
        <Route exact path="/view/protocol" component={Protocol}/>
        <Route component={NotFound} />
      </Switch>
      <Message />
    </div>
  </ConnectedRouter>;
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js